import { Flex, QnaIcon, Text } from "@fluentui/react-northstar";
import { TeamsSurveyQnaResponse } from "@teams/types";
import { SurveyDTO } from "@teams/types/api";
import React, { useMemo } from "react";

import { QnaResultsCard } from "./QnaResultsCard";

export const QnaSurveyCardBody: React.FC<{
  survey: SurveyDTO;
  responses: TeamsSurveyQnaResponse[];
}> = ({ survey, responses }) => {
  const [topThree, approved] = useMemo(() => {
    const approvedResponses = responses.filter(r => r.state === "approved");
    const unfocused = approvedResponses.filter(r => !r.focused);
    const focused = approvedResponses.filter(r => r.focused);
    const sorted = unfocused.sort(
      (a, b) => b.stateChangedAt.getTime() - a.stateChangedAt.getTime()
    );
    return [[...focused, ...sorted].slice(0, 3), approvedResponses];
  }, [responses]);

  const appovedDisplay = `${approved.length} approved`;
  const queuedDisplay = `${responses.filter(r => r.state === "pending").length || 0} queued`;

  return (
    <Flex column gap="gap.smaller">
      <Text content={`${appovedDisplay}${survey.role === "own" ? `, ${queuedDisplay}` : ""}`} />
      {topThree.map(r => (
        <QnaResultsCard survey={survey} response={r} onChanged={() => {}} compact />
      ))}

      {!!approved.length && (
        <Text
          align="center"
          weight="bold"
          content={`Showing ${Math.min(2, approved.length)} of ${approved.length}`}
        />
      )}

      {approved.length === 0 && (
        <Flex column hAlign="center" gap="gap.medium">
          <Text as="div" content={`No questions`} align="center" size="large" />
          <QnaIcon size="largest" />
        </Flex>
      )}
    </Flex>
  );
};
